"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledLinkList = _styledComponents["default"].div.attrs({
  className: 'fuse-link-list'
}).withConfig({
  displayName: "styled-link-list__StyledLinkList",
  componentId: "sc-15t8sed-0"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space6);justify-content:center;text-align:center;"]);
var _default = exports["default"] = StyledLinkList;